/**
 * Voltalize Logger — fire-and-forget device connection & config logging
 * Uses sendBeacon (survives page unload) with fetch fallback.
 */
(function() {
"use strict";

class VotalizeLogger {
    constructor(endpoint) {
        this._endpoint = endpoint;
        this._configSent = false;
    }

    /**
     * Log a connection event (connect/disconnect)
     */
    logConnection(app, event, deviceName, deviceType, language) {
        this._send({
            type: 'connection',
            app,
            event,
            deviceName: deviceName || undefined,
            deviceType: deviceType || undefined,
            language: language || undefined,
            timestamp: new Date().toISOString()
        });
    }

    /**
     * Log a config snapshot (sent once per connection)
     */
    logConfig(app, deviceName, config) {
        if (this._configSent) return;
        this._configSent = true;
        this._send({
            type: 'config',
            app,
            deviceName: deviceName || undefined,
            config,
            timestamp: new Date().toISOString()
        });
    }

    /**
     * Reset state on disconnect (allows config to be sent again on next connection)
     */
    reset() {
        this._configSent = false;
    }

    _send(payload) {
        if (!this._endpoint) return;
        try {
            const json = JSON.stringify(payload);
            // Prefer sendBeacon — survives page navigation/close
            if (navigator.sendBeacon) {
                const blob = new Blob([json], { type: 'text/plain' });
                const sent = navigator.sendBeacon(this._endpoint, blob);
                if (sent) return;
            }
            // Fallback: fetch with keepalive
            fetch(this._endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: json,
                keepalive: true
            }).catch(() => {});
        } catch (e) {
            // Never break the app
        }
    }
}

// Expose globally
window.VotalizeLogger = VotalizeLogger;

})();
